import { dcnb } from 'cnbuilder';

export const root = ({ type, isOpen }) => dcnb(
  'su-modal su-fixed su-w-screen su-h-full su-overscroll-contain su-overflow-y-scroll su-overflow-x-hidden su-top-0 su-left-0 su-items-center su-justify-center su-z-[60]',
  {
    'su-flex': isOpen,
    'su-hidden': !isOpen,
    'su-bg-saa-black-dark': type === 'trip-filter',
    'su-bg-cardinal-red-xdark': type === 'main-menu',
    'su-bg-white': type === 'mega-menu',
    'su-bg-saa-black su-bg-opacity-[97%]':
        type !== 'trip-filter' && type !== 'main-menu' && type !== 'mega-menu',
  },
);
export const wrapper = ({ type }) => dcnb(
  'su-absolute su-basefont-19 su-pointer-events-auto',
  type === 'timeout'
    ? 'su-top-1/2 su-left-1/2 su--translate-y-1/2 su--translate-x-1/2'
    : 'su-w-screen su-h-full',
);

export const closeButtonWrapper = ({ type }) => dcnb({
  'su-cc su-flex su-justify-end': type !== 'trip-filter',
  'su-fixed su-top-0 su-right-20 sm:su-right-30 md:su-right-50 su-z-[60] su-rs-pt-1':
      type === 'trip-filter',
});
export const closeButton = ({ type }) => dcnb(
  'su-group su-bg-transparent su-font-semibold hocus:su-underline su-text-m1 su-flex su-items-end su-absolute su-top-22 su-z-10',
  {
    'su-text-white hocus:su-text-white hocus:su-bg-digital-red-xlight hocus:su-rounded-full':
        type === 'main-menu',
    'hocus:su-bg-transparent': type !== 'main-menu',
    'su-text-black': type === 'timeout',
    'su-text-black hocus:su-bg-white hocus:su-text-digital-red':
        type === 'mega-menu',
    'su-text-white hocus:su-text-digital-red-xlight':
        type !== 'mega-menu' && type !== 'timeout',
    'su-right-0': type === 'trip-filter',
    'su-right-20': type !== 'trip-filter',
  },
);
export const closeIcon = ({ type }) => dcnb('su-inline-block su-h-[1.1em] su-w-[1.1em]', {
  'su-transition-colors group-hover:su-text-palo-verde-light group-focus:su-text-palo-verde-light':
      type === 'trip-filter',
  'su-h-[1.3em] su-w-[1.3em] !su-ml-0 su-p-2':
      type === 'main-menu' || type === 'mega-menu',
  'su-ml-4': type !== 'main-menu',
});
